import React, { useEffect, useState } from 'react';
import { useGetQueueAttachmentQuery } from 'hooks/queue';
import { Attachment } from 'presentation/components/Queue/Chat/Chat';
import Loading from 'components/Loading';

interface AttachmentThumbnailProps {
  attachment: Attachment;
}

const AttachmentThumbnail: React.FC<AttachmentThumbnailProps> = ({ attachment }) => {
  const { attachmentId, fileType } = attachment;
  const { data: blob, isLoading } = useGetQueueAttachmentQuery(attachmentId, fileType || '');
  const [imageUrl, setImageUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!blob) return;

    const url = URL.createObjectURL(blob);
    setImageUrl(url);

    return () => {
      URL.revokeObjectURL(url);
    };
  }, [blob]);

  if (isLoading || !imageUrl) {
    return (
      <div
        style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#f5f5f5',
        }}
      >
        <Loading />
      </div>
    );
  }

  return (
    <img
      src={imageUrl}
      alt={attachment.filename}
      style={{
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        display: 'block',
      }}
    />
  );
};

export default AttachmentThumbnail;
